export default __webpack_public_path__ + "assets/enterprise-three-two-small.2cfdd263d8e80c2d313ccb50c012fca8.png";